/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../../app/@shared/tracking/tracking.module';
import * as import2 from '@angular/http';
import * as import3 from 'ngx-cookie/index';
import * as import4 from '../../../../app/@shared/auth/auth.module';
import * as import5 from 'ngx-cookie/src/cookie-options-provider';
import * as import6 from '../../../../app/@shared/tracking/error-tracking.service';
import * as import7 from './tracking.component.ngfactory';
import * as import8 from '../../../../app/@shared/auth/auth.service';
import * as import9 from '../../../../app/@shared/tracking/tracking.config';
class TrackingModuleInjector extends import0.ɵNgModuleInjector<import1.TrackingModule> {
  _HttpModule_0:import2.HttpModule;
  _CookieModule_1:import3.CookieModule;
  _AuthModule_2:import4.AuthModule;
  _TrackingModule_3:import1.TrackingModule;
  __BrowserXhr_4:import2.BrowserXhr;
  __ResponseOptions_5:import2.BaseResponseOptions;
  __XSRFStrategy_6:import1.NoXSRFStrategy;
  __XHRBackend_7:import2.XHRBackend;
  __RequestOptions_8:import2.BaseRequestOptions;
  __Http_9:any;
  __CookieOptionsProvider_10:import5.CookieOptionsProvider;
  __ErrorTracking_11:import6.ErrorTracking;
  constructor(parent:import0.Injector) {
    super(parent,[import7.TrackingComponentNgFactory],([] as any[]));
  }
  get _BrowserXhr_4():import2.BrowserXhr {
    if ((this.__BrowserXhr_4 == null)) { (this.__BrowserXhr_4 = new import2.BrowserXhr()); }
    return this.__BrowserXhr_4;
  }
  get _ResponseOptions_5():import2.BaseResponseOptions {
    if ((this.__ResponseOptions_5 == null)) { (this.__ResponseOptions_5 = new import2.BaseResponseOptions()); }
    return this.__ResponseOptions_5;
  }
  get _XSRFStrategy_6():import1.NoXSRFStrategy {
    if ((this.__XSRFStrategy_6 == null)) { (this.__XSRFStrategy_6 = new import1.NoXSRFStrategy()); }
    return this.__XSRFStrategy_6;
  }
  get _XHRBackend_7():import2.XHRBackend {
    if ((this.__XHRBackend_7 == null)) { (this.__XHRBackend_7 = new import2.XHRBackend(this._BrowserXhr_4,this._ResponseOptions_5,this._XSRFStrategy_6)); }
    return this.__XHRBackend_7;
  }
  get _RequestOptions_8():import2.BaseRequestOptions {
    if ((this.__RequestOptions_8 == null)) { (this.__RequestOptions_8 = new import2.BaseRequestOptions()); }
    return this.__RequestOptions_8;
  }
  get _Http_9():any {
    if ((this.__Http_9 == null)) { (this.__Http_9 = import2.ɵc(this._XHRBackend_7,this._RequestOptions_8)); }
    return this.__Http_9;
  }
  get _CookieOptionsProvider_10():import5.CookieOptionsProvider {
    if ((this.__CookieOptionsProvider_10 == null)) { (this.__CookieOptionsProvider_10 = new import5.CookieOptionsProvider(this.parent.get(import5.COOKIE_OPTIONS),this)); }
    return this.__CookieOptionsProvider_10;
  }
  get _ErrorTracking_11():import6.ErrorTracking {
    if ((this.__ErrorTracking_11 == null)) { (this.__ErrorTracking_11 = new import6.ErrorTracking(this.parent.get(import8.Auth),this.parent.get(import9.TRACKING_CONFIG))); }
    return this.__ErrorTracking_11;
  }
  createInternal():import1.TrackingModule {
    this._HttpModule_0 = new import2.HttpModule();
    this._CookieModule_1 = new import3.CookieModule();
    this._AuthModule_2 = new import4.AuthModule();
    this._TrackingModule_3 = new import1.TrackingModule();
    return this._TrackingModule_3;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.HttpModule)) { return this._HttpModule_0; }
    if ((token === import3.CookieModule)) { return this._CookieModule_1; }
    if ((token === import4.AuthModule)) { return this._AuthModule_2; }
    if ((token === import1.TrackingModule)) { return this._TrackingModule_3; }
    if ((token === import2.BrowserXhr)) { return this._BrowserXhr_4; }
    if ((token === import2.ResponseOptions)) { return this._ResponseOptions_5; }
    if ((token === import2.XSRFStrategy)) { return this._XSRFStrategy_6; }
    if ((token === import2.XHRBackend)) { return this._XHRBackend_7; }
    if ((token === import2.RequestOptions)) { return this._RequestOptions_8; }
    if ((token === import2.Http)) { return this._Http_9; }
    if ((token === import5.CookieOptionsProvider)) { return this._CookieOptionsProvider_10; }
    if ((token === import6.ErrorTracking)) { return this._ErrorTracking_11; }
    return notFoundResult;
  }
  destroyInternal():void {
  }
}
export const TrackingModuleNgFactory:import0.NgModuleFactory<import1.TrackingModule> = new import0.NgModuleFactory<any>(TrackingModuleInjector,import1.TrackingModule);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcubW9kdWxlLm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvYXBwL0BzaGFyZWQvdHJhY2tpbmcvdHJhY2tpbmcubW9kdWxlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/@shared/tracking/tracking.module.ngfactory.ts